import React from 'react';
import CustomModal from '../../../../../components/Modal/CustomModal';
import DeliveryRecordModalApp from '../Functionality/DeliveryRecordModalApp';
import { CleanIcon, DeliveryDocument, FileTracking } from '../../../../../components/buttons/IconButtons';
import CustomCard from './../../../../../components/CustomCard';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';
import CustomAddChipSearch from '../../../../../components/CustomAddChipSearch';
import { CustomTextField } from '../../../../../components/CustomTextField';
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import { ACTION_MODEL } from '../../../../../Helpers/ActionModel';
import { FILE_TYPE } from '../../../../../Helpers/fileType';
import { getModelSimpleSearch, userListToLabelEmailPhoneValue } from '../../../../../Apis/functions';
import { SUGGESTION_MODE_OPTION } from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import CustomDateTimePicker from '../../../../../components/CustomDateTimePicker';
import { SERVICE_ADVANCED_SEARCH_SIMPLE_SEARCH_USER } from '../../../../../reduxToolkit/Commons/CommonsApi';
import { TABLES } from '../../../../../Apis/Tables';
import { STATUS_MODEL } from '../../../../../enums/statusEnum';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const DeliveryRecordModal = (props) => {
    const {onHide} = props;
    const {
        t,
        handleConfirm,
        handleClear,
        photoPicker,
        setPhotoPicker,
        emptyFields,
        disabled,
        item,
        handleChange,
        selectedList,
        userTypeToSearch,
        setSelectedList,
        displayModal,
        setDisplayModal,
        clear,
        setClear,
        contractorId,
    } = DeliveryRecordModalApp({
        onHide
    });

    return (
        <CustomModal
            {...props}
            size='lg'
            display={displayModal}
            buttonConfirm='confirm'
            confirmButton={true}
            cancelButton={true}
            onConfirm={handleConfirm}
            classNameBody='m-0 p-0'
            onHide={onHide}
            topLeftHeader={
                <div className='d-flex align-items-center pb-3'>
                    <FileTracking />
                    <p className='fs-24px ibl-font-w-600  font-color-general-950 font-color-primary-600 ml-2'>
                        {t('record_delivery')}
                    </p>
                    <div className='vertical-separator h-auto' />
                </div>
            }
        >
            <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                <DeliveryDocument className={'w-100'} />

                <div className='mr-3 ml-3'>
                    <div className='d-flex justify-content-end mt-3 mb-3'>
                        <ButtonIcon
                            id='btn_drm_clean'
                            Icon={CleanIcon}
                            onClick={handleClear}
                            emptyFields={emptyFields}
                            title={'clear_instances'}
                            className={'btn-clean-secondary-600'}
                            tooltipPlacement={'right'}
                            iconProps={'btn-icon-svg-12px icon-color-general-00'}
                        />
                    </div>
                    <CustomDateTimePicker
                        id={'dp_drm_date_time'}
                        name={'dateTime'}
                        disabled={disabled}
                        onChange={(e) => {
                            handleChange({ target: { value: e, name: 'dateTime' } });
                        }}
                        trans={'date_and_time'}
                        value={item?.dateTime}
                        required={true}
                        disablePast={false}
                        openTo={'day'}
                        emptyFields={emptyFields}
                        disableFuture={true}
                    />
                    <CustomAddChipSearch
                        autocompleteId={'slt_drm_employee'}
                        buttonId={'btn_drm_employee'}
                        selectedList={selectedList}
                        setSelectedList={setSelectedList}
                        userTypeIdsSearch={[userTypeToSearch]}
                        label='employee'
                        emptyFields={emptyFields}
                        required={true}
                        reset={false}
                        keyId={'userId'}
                        showSubSection={true}
                        sanitizeDataList={userListToLabelEmailPhoneValue}
                        completeWidth={true}
                        api={SERVICE_ADVANCED_SEARCH_SIMPLE_SEARCH_USER}
                        bodyApi={getModelSimpleSearch(TABLES.USER_BY_CONTRACTOR_ID, {userId: contractorId,  userTypeIds: [STATUS_MODEL.ACTIVE],})}

                    />
                    <div className='mb-4'>
                        <p className='ibl-font-w-700 text-uppercase text-center mb-3'>{t('provide_reason_delivery')}</p>
                    </div>
                    <CustomTextField
                        id={'txt_drm_name'}
                        length={128}
                        name={'deliveryNote'}
                        value={item?.deliveryNote}
                        emptyFields={emptyFields}
                        trans={'delivery_note'}
                        type={'text'}
                        placeholder={t('add_delivery_details')}
                        onChange={handleChange}
                        required={true}
                        multiline={true}
                    />
                    <div className='mb-4'>
                        <p className='ibl-font-w-700 text-uppercase text-center mb-3'>
                            {t('attach_evidence_required')}
                        </p>
                    </div>
                    <div className='col-12 mb-4'>
                        <CustomPhotoPicker
                            id='fu_drm_file'
                            photoPicker={photoPicker}
                            setPhotoPicker={setPhotoPicker}
                            actionModel={ACTION_MODEL.CREATE}
                            accept={{ ...FILE_TYPE.IMAGE_FILES }}
                            required={true}
                            emptyFields={emptyFields}
                            validateFace={false}
                            showBtnCamera={true}
                            showPreview={false}
                            typeSuggestions={SUGGESTION_MODE_OPTION.MATERIAL_AND_EQUIPMENT}
                            setDisplayModal={setDisplayModal}
                            clear={clear}
                            setClear={setClear}
                        />
                    </div>
                </div>
            </CustomCard>
        </CustomModal>
    );
};

export default DeliveryRecordModal;
